import { useCallback, useRef, useState } from 'react';

const useLongPress = (
  onLongPress: (callbackValue?: any, event?: any) => any,
  onClick: (callbackValue?: any, event?: any) => any,
  { shouldPreventDefault = true, delay = 500 } = {},
  onClickValue: any,
  onLongPressValue: any
) => {
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const timeout: React.MutableRefObject<any> = useRef();
  const target: React.MutableRefObject<any> = useRef();

  const start = useCallback(
    (event: any) => {
      event.persist();
      if (shouldPreventDefault && event.target) {
        event.target.addEventListener('touchend', preventDefault, {
          passive: false,
        });
        target.current = event.target;
      }
      timeout.current = setTimeout(() => {
        onLongPress(onLongPressValue, event);
        setLongPressTriggered(true);
      }, delay);
    },
    [onLongPress, delay, shouldPreventDefault]
  );

  const clear = useCallback(
    (event: any, shouldTriggerClick = true) => {
      event.persist();
      timeout.current && clearTimeout(timeout.current);
      shouldTriggerClick && !longPressTriggered && onClick(onClickValue, event);
      setLongPressTriggered(false);
      if (shouldPreventDefault && target.current) {
        target.current.removeEventListener('touchend', preventDefault);
      }
    },
    [shouldPreventDefault, onClick, longPressTriggered]
  );

  return {
    onMouseDown: (e: any) => start(e),
    onTouchStart: (e: any) => start(e),
    onMouseUp: (e: any) => clear(e),
    onMouseLeave: (e: any) => clear(e, false),
    onTouchEnd: (e: any) => clear(e),
  };
};

const isTouchEvent = (event: any) => {
  return 'touches' in event;
};

const preventDefault = (event: any) => {
  if (!isTouchEvent(event)) return;

  if (event.touches.length < 2 && event.preventDefault) {
    event.preventDefault();
  }
};

export default { useLongPress };
